import useSession from '../hooks/useSession'

import Page from '@/gf/components/Page'
import ProductDiagnostics from '@/gf/components/ProductDiagnostics'
import Frame from '../components/Frame'

const breadcrumbs = {
  copy: 'Back to Dashboard',
  crumbs: [
    { name: 'Products', href: '/products' },
    { name: 'Diagnostics', href: '/product-diagnostics' },
  ],
}

const ProductDiagnosticsPage = () => {
  const { store } = useSession()

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page title="Product Diagnostics">
        <ProductDiagnostics storeId={store.id} />
      </Page>
    </Frame>
  )
}

export default ProductDiagnosticsPage
